import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { EstateRelatedDto } from "@1games-ru/region-shared/dist/types/estate/estate";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { playerInfoSelector } from "@/domains/player/slice";
import PlayerMenuCharacterBattlePassCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterBattlePassCardContainer";
import PlayerMenuCharacterFactionCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterFactionCardContainer";
import PlayerMenuCharacterFamilyCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterFamilyCardContainer";
import PlayerMenuCharacterJobCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterJobCardContainer";
import PlayerMenuCharacterProgressCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterProgressCardContainer";
import PlayerMenuCharacterStateCardContainer from "@/domains/playerMenu/containers/character/data/PlayerMenuCharacterStateCardContainer";
import PlayerMenuContent from "@/domains/playerMenu/components/PlayerMenuContent";
import PlayerMenuContentProgress from "@/domains/playerMenu/components/PlayerMenuContentProgress";
import PlayerMenuContentTitle from "@/domains/playerMenu/components/PlayerMenuContentTitle";
import PlayerMenuCharacterEstateCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterEstateCard";

export default function PlayerMenuCharacterDataContainer() {
  const { t } = useTranslation("playerMenu");
  const playerInfo = useAppSelector(playerInfoSelector);
  const [estates, setEstates] = useState<EstateRelatedDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const getEstates = useCallback(async () => {
    const response = await EstateMpProvider.getRelated();

    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error("Не удалось загрузить список недвижимости");
      console.log("Failed fetch loadSlots() - EstateMpProvider.getRelated()", response);
      return;
    }

    const residences = [];
    response.data.items.forEach((item) => {
      if (item.entity.type === EstateType.HotelRoom) {
        return;
      }

      if (item.hasResidence) {
        residences.push(item);
      }

      setEstates(residences);

      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    getEstates();
  }, []);

  const header = <PlayerMenuContentTitle>{t("playerMenu.tabTitle.Basic")}</PlayerMenuContentTitle>;

  if (!playerInfo?.character) return null;

  return (
    <PlayerMenuContent header={header}>
      {/* {isLoading ? (
        <PlayerMenuContentProgress />
      ) : ( */}
      <div className="flex flex-wrap gap-5">
        <PlayerMenuCharacterProgressCardContainer />
        <PlayerMenuCharacterStateCardContainer />
        <PlayerMenuCharacterBattlePassCardContainer />
        <PlayerMenuCharacterFamilyCardContainer />
        <PlayerMenuCharacterFactionCardContainer />
        <PlayerMenuCharacterJobCardContainer />
        {estates.length > 0 && (
          <>
            {estates.map((item) => (
              <PlayerMenuCharacterEstateCard key={item.id} {...item} />
            ))}
          </>
        )}
      </div>
      {/* )} */}
    </PlayerMenuContent>
  );
}
